/* External dependencies */
import CognitoClient from '@mancho.devs/cognito';
import { Observable } from 'rxjs';
import { filter, mergeMap, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getSession } from '../../../../../client/graphql';
import {
  AuthEpicsActions,
  AuthEpicsActionTypes,
  ConfirmPassword,
  confirmPasswordFailed,
  confirmPasswordSucceeded,
  ForgotPassword,
  forgotPasswordFailed,
  forgotPasswordSucceeded,
  InitClientFailed,
  InitClientRequest,
  InitClientSucceeded,
  signInFailed,
  signInSucceeded,
  SignInUser,
  signOutFailed,
  signOutSucceeded,
  signUpFailed,
  signUpSucceeded,
  SignUpUser,
  VerificationCode,
  verificationCodeFailed,
  verificationCodeSucceded,
} from './action';

const cognitoClient = new CognitoClient({
  UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
  ClientId: process.env.GATSBY_COGNITO_CLIENT_ID,
});

export function signUpEpic(action$): Observable<AuthEpicsActions> {
  return action$.pipe(
    filter((action: AuthEpicsActions) => action.type === AuthEpicsActionTypes.SIGN_UP),
    switchMap(({ email, password }: SignUpUser) =>
      cognitoClient.signUp(email, password).then(signUpSucceeded).catch(signUpFailed),
    ),
  );
}

export function signUpVerificationCode(action$): Observable<AuthEpicsActions> {
  return action$.pipe(
    filter((action: AuthEpicsActions) => action.type === AuthEpicsActionTypes.VERIFICATION_CODE),
    mergeMap(({ email, code }: VerificationCode) =>
      cognitoClient.signUpConfirmCode(email, code).then(verificationCodeSucceded).catch(verificationCodeFailed),
    ),
  );
}

export function signInEpic(action$): Observable<AuthEpicsActions> {
  return action$.pipe(
    filter((action: AuthEpicsActions) => action.type === AuthEpicsActionTypes.SIGN_IN),
    switchMap(({ email, password }: SignInUser) =>
      cognitoClient.signIn(email, password).then(signInSucceeded).catch(signInFailed),
    ),
  );
}

export function forgotPasswordEpic(action$): Observable<AuthEpicsActions> {
  return action$.pipe(
    filter((action: AuthEpicsActions) => action.type === AuthEpicsActionTypes.FORGOT_PASSWORD),
    switchMap(({ email }: ForgotPassword) =>
      cognitoClient.forgotPassword(email).then(forgotPasswordSucceeded).catch(forgotPasswordFailed),
    ),
  );
}

export function confirmPasswordEpic(action$): Observable<AuthEpicsActions> {
  return action$.pipe(
    filter((action: AuthEpicsActions) => action.type === AuthEpicsActionTypes.CONFIRM_PASSWORD),
    switchMap(({ email, verificationCode, newPassword }: ConfirmPassword) =>
      cognitoClient
        .confirmPassword(email, verificationCode, newPassword)
        .then(confirmPasswordSucceeded)
        .catch(confirmPasswordFailed),
    ),
  );
}

export function initialClientEpic(action$) {
  return action$.pipe(
    filter((action: InitClientRequest) => action.type === AuthEpicsActionTypes.INIT_CLIENT_REQUEST),
    switchMap(({}) => getSession().then(InitClientSucceeded).catch(InitClientFailed)),
  );
}

export function signOutEpic(action$) {
  return action$.pipe(
    filter((action: AuthEpicsActions) => action.type === AuthEpicsActionTypes.SIGN_OUT),
    switchMap(() => cognitoClient.signOut().then(signOutSucceeded).catch(signOutFailed)),
  );
}
